<template>
<div id="appWrapper" class="app-wrapper">
	<div class="main-container" style="margin-left: 0;">
		<div class="nav-wrapper" style="overflow:hidden; background: white;  box-shadow: rgb(189, 189, 189) 0px 0px 4px; position: fixed; top: 0; width: 100vw; z-index: 100; height: 70px;">
			<div class="nav-left" style="float:left;">
				<img style="height: 70px;" :src="logo" />
			</div>
			<div class="nav-right" style="float:right; padding-right: 98px; height: 100%;">
				<div class="wrapper">
					<div :class="item.selected ? 'item selected' : 'item'" v-for="(item, index) in topNav" :key="index" @click="onNavClicked(item, null, null)">
						<el-popover style="padding: 0px;" placement="bottom" width="150" trigger="hover" :disabled="item.children.length === 0">
							<div>
								<!-- <div style="float:left; width: 200px; height: 200px; overflow:hidden;">
									<img style="height: 100%;" :src="item.content ? item.content.picture : ''" />
								</div>
								<div style="float:left; width: 220px; padding-left: 20px;">
									{{ item.content ? item.content.text : "" }}
								</div> -->
								<div id="children" v-for="(t, i) in item.children" :key="i" @click="onNavClicked(item, t, i)">
									{{t.name}}
								</div>
							</div>
							<div slot="reference" @click="visible = !visible">
								{{ item.name }}
							</div>
						</el-popover>
					</div>
				</div>
			</div>
		</div>
		<div style="padding-top: 90px; padding-left: 80px; padding-right: 80px;">
			<router-view></router-view>
		</div>
		<div style="width: 100%; height: 400px; background: #333">
			<div class="bottom-nav" style="border-bottom: 1px solid #646464;">
				<div class="wrapper">
					<div class="title">
						集团总部
					</div>
					<div class="list">
						<div>江苏省昆山市周市镇优比路原创型工业</div>
						<div>0512-57626666</div>
						<div>0512-81639999</div>
					</div>
				</div>
				<div class="wrapper">
					<div class="title">
						生产基地
					</div>
					<div class="list">
						<div>江苏省泰兴市经济开发区通园路9号</div>
						<div>0523-87978888</div>
						<div>0523-87979999</div>
					</div>
				</div>
				<div v-for="(item, index) of qrcodes" :key="index" class="right">
					<div>
						<img :src="item" />
					</div>
				</div>
			</div>
			<div style="text-align:center; color:white; padding-top: 20px;">
			  董事长寄语：心在哪里，成功就在哪里
			</div>
			<div style="padding: 10px 80px; color: #969696; text-align:center;">
				<a href="https://beian.miit.gov.cn">苏ICP备2021011847号</a>
			</div>
			<div style="padding: 5px 80px; color: #969696; text-align:center;">
				Copyright (C) 2010 All rights Reserved. 江苏天脉集团
				版权所有未经书面允许禁止转载本站信息内容
			</div>
		</div>
	</div>
</div>
</template>

<script>
import ResizeMixin from "./mixin/ResizeHandler";
import briefPic from "@/assets/images/banner03.jpg";
import logo from "@/assets/images/logo.png";
import {
	website
} from "@/api/page-api";

export default {
	name: "layout-admin",
	components: {},
	mixins: [ ResizeMixin ],
	watch: {
		$route( to, from ) {
			console.log( to, from )
			const _path = to.path.match( /[a-z A-Z -]+/ )[ 0 ];
			const _find = this.topNav.find( _el => _el.path === _path );
			if ( _find && !_find[ "selected" ] ) {
				this.topNav.forEach( ( item, i ) => {
					item.selected = false;
				} );
				_find[ "selected" ] = true;
			}
		}
	},
	created() {
		website.bottomNav
			.getQrcode()
			.then( res => {
				this.qrcodes = [];
				res.forEach( ( item, i ) => {
					item[ "qrcode" ][ "url" ] = this.processImageUrl( item[ "qrcode" ][ "url" ] );
					this.qrcodes.push( item[ "qrcode" ][ "url" ] );
				} );
				console.log( res );
			} )
			.catch( err => {
				console.log( err );
			} );
		website.topNav
			.getList()
			.then( res => {
				res[ 0 ][ 'selected' ] = true;
				this.topNav = res;
				const _path = this.$router.currentRoute.path.match( /[a-z A-Z -]+/ )[ 0 ];
				const _find = this.topNav.find( _el => _el.path === _path );
				if ( _find && !_find[ "selected" ] ) {
					this.topNav.forEach( ( item, i ) => {
						item.selected = false;
					} );
					_find[ "selected" ] = true;
				}
				console.log( res, 'topnav' );
			} )
			.catch( err => {
				console.log( err );
			} );
	},
	data() {
		return {
			qrcodes: [],
			visible: false,
			logo,
			topNav: [
      ]
		};
	},
	computed: {},
	methods: {
		onNavClicked( params, child, index ) {
			const _path = this.$router.currentRoute.path;
			let _router = params.path;
			if ( child ) {
				_router = `${params.path}?index=${index}&name=${child.name}`
			}
			if ( "/" + params[ "path" ] !== _path ) {
				this.topNav.forEach( ( item, i ) => {
					item[ "selected" ] = false;
				} );
				params[ "selected" ] = true;
				this.$router.push( {
					path: _router,
					query: {
						t: Date.now()
					}
				} );
			} else {
				this.$router.replace( {
					path: _router,
					query: {
						t: Date.now()
					}
				} )
			}
		}
	}
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "src/styles/mixin.scss";
@import "src/styles/variables.scss";
.app-wrapper {
    @include clearfix;
    position: relative;
    height: 100%;
    width: 100%;
    overflow-x: hidden;
    overflow-y: scroll;
}
.nav-wrapper {
    .nav-left {
        float: left;
        margin-left: 80px;
    }
    .nav-right {
        float: right;
        .item {
            float: left;
            padding: 0 30px;
            line-height: 70px;
            cursor: pointer;
            &:hover {
                background: $main;
                color: white;
            }
        }
        .selected {
            background: $main;
            color: white;
        }
    }
}

#children {
    float: left;
    line-height: 50px;
    width: 100%;
    background: #f0f0f0;
    text-align: center;
    margin-bottom: 2px;
    cursor: pointer;
    &:hover {
        background: $main;
        color: white;
    }
    &:last-child {
        margin-bottom: 0;
    }
}

.bottom-nav {
    padding: 40px 80px;
    overflow: hidden;
    .wrapper {
        float: left;
        color: white;
        margin-right: 100px;
        line-height: 30px;
        div {
            cursor: pointer;
        }
        .title {
            font-size: 22px;
            margin-bottom: 20px;
        }
        .list {
            div {
                opacity: 0.5;
                &:hover {
                    opacity: 1;
                }
            }
        }
    }
    .right {
        float: right;
        div {
            width: 200px;
            img {
                width: 100%;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/Layout.vue